const log = {
    invalid_type: 'Il tipo di registro non è valido.',
    invalid_time_window: '`end_time` deve essere successivo a `start_time`.',
};
export default Object.freeze(log);
